import Vue from "vue";

import FormLabel from "@/components/Forms/Fields/FormLabel";
import FormSubmit from "@/components/Forms/Fields/FormSubmit";
import FormCheckbox from "@/components/Forms/Fields/FormCheckbox";
import A11yVueDialog from "a11y-vue-dialog";
import VueFormulate from "@braid/vue-formulate";
import { de, en } from "@braid/vue-formulate-i18n";
import PortalVue from "portal-vue";
import VTooltip from "v-tooltip";

import { Plugin } from "vue-fragment";
import PrettyCheckbox from "pretty-checkbox-vue";

import locales from "@/model/locales";
import FormPassword from "@/components/Forms/Fields/FormPassword";

export default () => {
  Vue.use(PortalVue);
  Vue.use(A11yVueDialog);
  Vue.use(Plugin);
  Vue.use(PrettyCheckbox);
  Vue.use(VTooltip);

  Vue.component("FormLabel", FormLabel);
  Vue.component("FormSubmit", FormSubmit);
  Vue.component("FormCheckbox", FormCheckbox);
  Vue.component("FormPassword", FormPassword);

  Vue.use(VueFormulate, {
    plugins: [de, en],
    locale: "de",
    locales: locales,
    library: {
      password: {
        classification: "text",
        component: "FormPassword",
      },
      submit: {
        component: "FormSubmit",
      },
      checkbox: {
        component: "FormCheckbox",
      },
    },
    slotComponents: {
      label: "FormLabel",
    },
    slotProps: {
      label: ["tooltip"],
    },
  });
};
